import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idLead: string;
}

export function useGetEtapasLead(props: Props) {
  const fetchData = async () => {
    const LISTAR_ETAPAS = `${leadsWebEnviroment}/commom/leads/etapas-por-lead/v1/${props.idLead}`;
    const response = await instance.get(LISTAR_ETAPAS);
    return response?.data?.data;
  };

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["listar_etapas_lead", props.idLead],
    refetchOnWindowFocus: false,
  });

  return query;
}
